import { ButtonGroup, Button } from "@datapay-by-datacom/design-system";
import { useState } from "react";
import { OrgCategory } from "../../../generated/core-api";
import { OrgInviteCreateModal } from "./OrgInviteCreateModal";

interface OrgInviteActionsProps {
  category: OrgCategory;
  id: string;
}

export function OrgInviteActions({ category, id }: OrgInviteActionsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <ButtonGroup align="right">
        <Button variant="primary" onPress={openModal}>
          Create Invitation
        </Button>
      </ButtonGroup>

      <OrgInviteCreateModal
        category={category}
        id={id}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </>
  );
}
